// Mirror Causable.Api.Data.Enum.ErrorTypes 608/609; the messages match the English copy in their error categories.
export const DRAW_REMINDER_TIMES_INVALID_ERROR_TYPE = 608;
export const DRAW_REMINDER_DELIVERY_INVALID_ERROR_TYPE = 609;

export const DRAW_REMINDER_TIMES_INVALID_MESSAGE =
  'The draw reminder start time must be at least an hour before the end time, and the end time at or before the draw time. Otherwise no reminders are sent.';
export const DRAW_REMINDER_DELIVERY_INVALID_MESSAGE =
  'The notification frequency and chunk size must each be at least 1. Otherwise no reminders are sent.';
